/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSortAmountDownAlt,
  faSortAmountUpAlt,
} from '@fortawesome/pro-duotone-svg-icons';
import { loadRecords } from '../../actions/records';

class RecordTableHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    // States to handle up/down sorting UX
    this.state = { mouseHover: false, mouseClick: false };
  }

  handleLoad = () => {
    const {
      dispatch,
    } = this.props;
    dispatch({ type: 'SET_RECORDS_LOADING', payload: true });
    loadRecords()
      .then(() => {
        dispatch({ type: 'SET_RECORDS_LOADING', payload: false });
      }).catch(() => {
        dispatch({ type: 'SET_RECORDS_LOADING', payload: false });
      });
  };

  handleSort = (id) => {
    const {
      dispatch,
      sortInverse,
      sortTerm,
    } = this.props;

    let newSortTerm = id;
    let newSortInverse = sortInverse;

    // Conditional order important for [ down -> up -> off ] w/ changing sorts
    const setInitialSort = sortTerm === null && newSortTerm !== sortTerm;
    const setNewSort = newSortTerm !== sortTerm;
    const setInverseSort = sortTerm !== null && sortInverse === true;
    const setDefaultSort = sortTerm !== null && sortInverse === false;
    if (setInitialSort || setNewSort) {
      newSortInverse = true;
    } else if (setInverseSort) {
      newSortInverse = !sortInverse;
    } else if (setDefaultSort) {
      newSortTerm = null;
      newSortInverse = true;
    }

    return new Promise((resolve) => {
      dispatch({ type: 'SET_RECORDS_LOADING', payload: true });
      dispatch({ type: 'SET_RECORD_PAGE_IDX', payload: 0 });
      dispatch({ type: 'CLEAR_RECORD_BOOK' });

      dispatch({ type: 'SET_RECORD_SORT_INVERSE', payload: newSortInverse });
      dispatch({ type: 'SET_RECORD_SORT_TERM', payload: newSortTerm });
      resolve();
    });
  };

  render() {
    const { mouseHover, mouseClick } = this.state;
    const {
      sortInverse,
      sortTerm,
      model: {
        id,
        sortId,
        name,
        justify,
        style,
      },
    } = this.props;

    if (!name) { return <th aria-label="_" />; }

    // sortTerm is redux term to send to mmb api,
    // sortId and id are from ./models.js, assigning unqiue mmb api ids
    const currentSort = sortTerm === id || sortTerm === sortId;
    const sortIconOpacity = currentSort ? '1' : '0';

    return (
      <th
        className={[
          'pt-3 pb-0',
          justify ? `text-${justify}` : '',
          id.split('-')[0],
        ].join(' ')}
        style={style}
      >
        <span
          style={{
            cursor: sortId === -1 ? 'default' : 'pointer',
            userSelect: 'none',
          }}
          onMouseEnter={() => this.setState({ mouseHover: true })}
          onMouseLeave={() => this.setState({ mouseHover: false, mouseClick: false })}
          onClick={() => {
            this.setState({ mouseClick: true });
            if (!sortId || sortId !== -1) {
              this.handleSort(sortId || id)
                .then(this.handleLoad);
            }
          }}
          role="button"
          tabIndex={0}
        >
          {name}
        </span>
        {/* Down icon if: new sort OR clicked icon, still hovering */}
        <FontAwesomeIcon
          icon={!currentSort || (sortInverse && (!mouseHover || mouseClick))
            ? faSortAmountDownAlt
            : faSortAmountUpAlt}
          size="lg"
          className="ms-1"
          style={{
            opacity: mouseHover && !mouseClick && sortId !== -1
              ? '0.5'
              : sortIconOpacity,
          }}
        />
      </th>
    );
  }
}

const mapStateToProps = (store) => ({
  sortInverse: store.records.sortInverse,
  sortTerm: store.records.sortTerm,
  style: [],
});

export default connect(mapStateToProps)(RecordTableHeader);
